import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useUserContext } from '@module/mdrt-org/shared/components/providers/user-context';
import { Accordion } from '@shared/ui-components/accordion/accordion';
import { CheckboxField } from '@shared/ui-components/checkbox-field/checkbox-field';
import { type SearchCmsContent } from '../../../../graphql/get-search-cms-content';
import { type AdvancedFilterFormData, type AdvancedFilterOptions, type FilterSection } from '../../types/advanced-filter-form-data';
import { getCheckedItemCount } from '../../utils/get-checked-item-count';
import { getSectionLabel } from '../../utils/get-section-label';
import { FilterOptions } from '../filter-options/filter-options';
import styles from './filter-content.module.scss';
type FilterContentProps = {
  filterOptions: AdvancedFilterOptions;
  searchPageCmsContent: SearchCmsContent['searchPage'];
};
export const FilterContent = t0 => {
  const $ = _c(51);
  const {
    filterOptions,
    searchPageCmsContent
  } = t0;
  const {
    status
  } = useUserContext();
  const isAuthenticated = status === "authenticated";
  const [activeSection, setActiveSection] = useState(null);
  const {
    watch
  } = useFormContext();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => () => setActiveSection(null);
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useLayoutEffect(t1, t2);
  let T0;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[2] !== activeSection || $[3] !== filterOptions.source || $[4] !== filterOptions.topic || $[5] !== searchPageCmsContent?.SourceLabel || $[6] !== searchPageCmsContent?.TopicLabel || $[7] !== searchPageCmsContent?.YearLabel || $[8] !== watch) {
    const checkedCount = getCheckedItemCount(watch());
    let t9;
    if ($[16] !== activeSection) {
      t9 = sectionId => {
        if (activeSection === sectionId) {
          setActiveSection(null);
        } else {
          setActiveSection(sectionId);
        }
      };
      $[16] = activeSection;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    const handleSectionToggle = t9;
    let t10;
    if ($[18] !== activeSection || $[19] !== handleSectionToggle) {
      t10 = sectionId_0 => ({
        isExpanded: activeSection === sectionId_0,
        onChange: () => handleSectionToggle(sectionId_0)
      });
      $[18] = activeSection;
      $[19] = handleSectionToggle;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    const getSectionControlProps = t10;
    t5 = styles["filter-stack"];
    const t11 = getSectionLabel(searchPageCmsContent?.SourceLabel || "Source", checkedCount.source);
    let t12;
    if ($[21] !== getSectionControlProps) {
      t12 = getSectionControlProps("source");
      $[21] = getSectionControlProps;
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    let t13;
    if ($[23] !== filterOptions.source) {
      t13 = <FilterOptions filterOptions={filterOptions.source} sectionName="source" />;
      $[23] = filterOptions.source;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    t6 = <li className={styles["filter-stack__item"]}><Accordion headerLabel={t11} {...t12} iconPosition="right" withPlusMinusIcon={true}>{t13}</Accordion></li>;
    const t14 = getSectionLabel(searchPageCmsContent?.TopicLabel || "Topic", checkedCount.topic);
    let t15;
    if ($[25] !== getSectionControlProps) {
      t15 = getSectionControlProps("topic");
      $[25] = getSectionControlProps;
      $[26] = t15;
    } else {
      t15 = $[26];
    }
    let t16;
    if ($[27] !== filterOptions.topic) {
      t16 = <FilterOptions filterOptions={filterOptions.topic} sectionName="topic" />;
      $[27] = filterOptions.topic;
      $[28] = t16;
    } else {
      t16 = $[28];
    }
    t7 = <li className={styles["filter-stack__item"]}><Accordion headerLabel={t14} {...t15} iconPosition="right" withPlusMinusIcon={true}>{t16}</Accordion></li>;
    t4 = styles["filter-stack__item"];
    T0 = Accordion;
    t3 = getSectionLabel(searchPageCmsContent?.YearLabel || "Year", checkedCount.year);
    t8 = getSectionControlProps("year");
    $[2] = activeSection;
    $[3] = filterOptions.source;
    $[4] = filterOptions.topic;
    $[5] = searchPageCmsContent?.SourceLabel;
    $[6] = searchPageCmsContent?.TopicLabel;
    $[7] = searchPageCmsContent?.YearLabel;
    $[8] = watch;
    $[9] = T0;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    T0 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
    t8 = $[15];
  }
  let t9;
  if ($[29] !== filterOptions.year) {
    t9 = <FilterOptions filterOptions={filterOptions.year} sectionName="year" />;
    $[29] = filterOptions.year;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== T0 || $[32] !== t3 || $[33] !== t8 || $[34] !== t9) {
    t10 = <T0 headerLabel={t3} {...t8} iconPosition="right" withPlusMinusIcon={true}>{t9}</T0>;
    $[31] = T0;
    $[32] = t3;
    $[33] = t8;
    $[34] = t9;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== t10 || $[37] !== t4) {
    t11 = <li className={t4}>{t10}</li>;
    $[36] = t10;
    $[37] = t4;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== filterOptions.savedContent || $[40] !== isAuthenticated || $[41] !== searchPageCmsContent?.SavedContentLabel) {
    t12 = isAuthenticated && <CheckboxField isSwitch={true} label={searchPageCmsContent?.SavedContentLabel || "Saved content"} name={`savedContent.${filterOptions.savedContent[0].name}`} pushToRight={true} wrapperClassName={styles["switch-filter"]} />;
    $[39] = filterOptions.savedContent;
    $[40] = isAuthenticated;
    $[41] = searchPageCmsContent?.SavedContentLabel;
    $[42] = t12;
  } else {
    t12 = $[42];
  }
  let t13;
  if ($[43] !== t12) {
    t13 = <li className={styles["filter-stack__item"]}>{t12}</li>;
    $[43] = t12;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  let t14;
  if ($[45] !== t11 || $[46] !== t13 || $[47] !== t5 || $[48] !== t6 || $[49] !== t7) {
    t14 = <ul className={t5}>{t6}{t7}{t11}{t13}</ul>;
    $[45] = t11;
    $[46] = t13;
    $[47] = t5;
    $[48] = t6;
    $[49] = t7;
    $[50] = t14;
  } else {
    t14 = $[50];
  }
  return t14;
};